import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getHeaderTitle", "action", "actionMetadata", "hasMarketingEmailAccess", "flowObjectTypeId", "actionId"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import EmailActionSummary from 'automation-ui-action-features/actions/email/EmailActionSummary';
import { useEmailStats } from 'automation-ui-action-features/actions/email/hooks/emailStatsHooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function EmailActionCard(_ref) {
  let {
      getHeaderTitle,
      action,
      actionMetadata,
      hasMarketingEmailAccess,
      flowObjectTypeId,
      actionId
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    clickThroughRatio,
    goalsMet
  } = useEmailStats({
    flowId: action.flowId,
    actionId: action.actionId,
    contentId: actionMetadata.contentId,
    flowObjectTypeId: flowObjectTypeId
  });
  const clickThroughLabel = clickThroughRatio !== undefined && /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.email.stats.clickThroughRate",
    options: {
      clickRate: /*#__PURE__*/_jsx(FormattedPercentage, {
        value: clickThroughRatio * 100,
        precision: 2
      })
    }
  });
  const goalLabel = goalsMet !== undefined && /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.email.stats.goalsMet",
    options: {
      count: goalsMet
    }
  });
  let stats = null;
  if (clickThroughLabel && goalLabel) {
    stats = /*#__PURE__*/_jsxs("div", {
      children: [clickThroughLabel, " / ", goalLabel]
    });
  } else if (clickThroughLabel || goalLabel) {
    stats = /*#__PURE__*/_jsx("div", {
      children: clickThroughLabel || goalLabel
    });
  }
  const content = hasMarketingEmailAccess ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EmailActionSummary, {
      metadata: actionMetadata,
      flowObjectTypeId: flowObjectTypeId
    }), stats]
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "automation-ui-action-features.action-features.email.noAccess"
  });
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, rest, {
    headerTitle: getHeaderTitle({
      actionId: actionId
    }),
    content: content
  }));
}